export default "skymp5-front/c97f9a61534aa6adb5ce52e0a909f328.svg";